import { AppEnvironment } from '@hw/hwfe/environments/environment.model.js';

export const environment: AppEnvironment = {
  production: true,
  sentryDsn: 'https://f45154a876ce1204cbcf5226adacf9bb@o4511160647614464.ingest.de.sentry.io/4511160835965008',
  hwfeSentryRelease: '1610068b8f3197e897d37e33546d340aabcdaaa6',
  hwbeUrl: 'https://hotwizards.net',
  vapidKey: 'BD0qwDyEM6tz6UbwnSZ4_x5s1P78bNeiujwVyqbOiONohXPYiVeTHTNJQ_hN3_LrNp-rpnzwFkMt5-IxA_QNMkE',
};
